/* Mama Jewels cart: every change goes by line item key, never by line number.
   Line numbers shift when an app (Cart Bot adds the milk kit) changes the cart after the
   page has loaded, so Dawn's index-based updates could hit the wrong product.
   - Remove: a personalised piece is removed together with its Globo add-on lines
     (linked by _gpo_parent_product_group); simple items by their own key.
   - Quantity (chains, ring sizer): /cart/change.js with the line key.
   Both reload the page afterwards, so the cart apps (milk kit, limits) re-evaluate. */
(function () {
  if (window.mjCartReady) return;
  window.mjCartReady = true;

  var root = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');

  function busy(el, on) {
    var line = el.closest('.mj-cart-line');
    var overlay = line && line.querySelector('.loading-overlay');
    if (overlay) overlay.classList.toggle('hidden', !on);
    if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
  }
  function fail(el) {
    busy(el, false);
    var errors = document.getElementById('cart-errors');
    if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
  }
  function post(url, body, el) {
    busy(el, true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        window.location.reload();
      })
      .catch(function () { fail(el); });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mj-remove]');
    if (!button) return;
    event.preventDefault();
    var updates = {};
    button.getAttribute('data-mj-remove').split(',').forEach(function (key) {
      if (key) updates[key] = 0;
    });
    post(root + '/update.js', { updates: updates }, button);
  });

  /* Capture phase: handled here before Dawn's <cart-items> sees it (it would use the line number). */
  document.addEventListener('change', function (event) {
    var input = event.target.closest('.mj-cart-qty .quantity__input[data-mj-key]');
    if (!input) return;
    event.stopPropagation();
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    post(root + '/change.js', { id: input.getAttribute('data-mj-key'), quantity: qty }, input);
  }, true);
})();
